import styled from '@emotion/styled';
import {Grid} from '@mui/material';

export const LogoGrid = styled(Grid)`
  background-color: ${prop => prop.theme.palette.common.white};
  padding: 0.75em 1em;
`;
